import { DesktopSettings } from '@honestica/electron-bridge-typing';
import { defaultDesktopSettings } from './defaultSettings.utils';

export function isDesktopSettingOfType(
  key: keyof DesktopSettings,
  type: 'number' | 'string' | 'boolean',
) {
  return typeof defaultDesktopSettings[key] === type;
}
